import i18next from 'i18next';
import {map} from 'rxjs/operators';

import {lazyDispatch} from 'web-app/util/redux/famly-app-helpers';
import ENV from 'web-app/config/environment';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import {showDeleteDialogObservable} from 'web-app/react/dialog/helpers';

import {entityFactoryCreator} from './index';

const onEntityInstanceCreated = entityName => {
    return GlobalEventActions.updateSuccess.action(i18next.t('entities.createSuccess', {entityName}));
};

const onEntityInstaceDeleted = entityName => {
    return GlobalEventActions.updateSuccess.action(i18next.t('entities.deleteSuccess', {entityName}));
};

const handleConfirmDelete = (msg: string) =>
    showDeleteDialogObservable({
        title: msg,
    }).pipe(
        map(choice => {
            if (choice === 'OK') {
                return 1;
            }
            return 0;
        }),
    );

const entity = entityFactoryCreator(
    lazyDispatch,
    ENV.isDevelopment,
    onEntityInstanceCreated,
    onEntityInstaceDeleted,
    RESTClient,
    handleConfirmDelete,
);

export default entity;
